const queryParams = {
    getParam: (queryType, location) => {
        const search = location.search;
        const params = new URLSearchParams(search);
        return params.get(queryType);
    },
    changeParamValue: (location, navigate, paramName, newValue) => {
        const oldSearchParams = location.search;
        const newSearchParams = new URLSearchParams(oldSearchParams);
        newSearchParams.set(paramName, newValue);
        navigate({
            ...location,
            search: newSearchParams.toString(),
        }, { replace: true });
    },
    changeArrayValue: (location, history, paramName, newValue) => {
        const oldSearchParams = location.search;
        const newSearchParams = new URLSearchParams(oldSearchParams);
        newSearchParams.set(paramName, newValue.join());
        history.replace({
            ...location,
            search: newSearchParams.toString(),
        });
    },
};
export default queryParams;
//# sourceMappingURL=queryParams.js.map